import { icon } from "@fortawesome/fontawesome-svg-core";
import ApiEndpoints from "../network/ApiEndPoints";
import InterpreterModeIcon from "@mui/icons-material/InterpreterMode";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import PersonIcon from "@mui/icons-material/Person";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import Person2Icon from "@mui/icons-material/Person2";
import Person4Icon from "@mui/icons-material/Person4";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import TrainIcon from "@mui/icons-material/Train";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import { client_men, flight1, maleAvatar } from "../iconsImports";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import StarIcon from "@mui/icons-material/Star";
export const RDDeviceStatus = {
  UNKNOWN: "UNKNOWN",
  NOT_READY: "NOTREADY",
  READY: "READY",
  SCANNING: "SCANNING",
  SCAN_SUCCESS: "SUCCESS",
  SCAN_FAILED: "FAILED",
};
export const AEPS = {
  CASH_WITHDRAWAL: "WAP",
  BALANCE_ENQUIRY: "BAP",
  STATEMENT: "SAP",
  APAY: "MZZ",
};
// only for transaction page
export const columnOptions = [
  "Route",
  "OrderId",
  "Operator",
  "EST",
  "Number",
  "Info",
  "Amount",
  "Closing",
  "Status",
  "Action",
];
// only for transaction page
export const nonAdminColOptions = {
  dd: ["OrderId", "Operator", "Number", "Info", "Amount", "Closing", "Status"],
  ret: ["OrderId", "Operator", "Number", "Info", "Amount", "Closing", "Status"],
  ad: [
    "OrderId",
    "EST",
    "Operator",
    "Number",
    "Info",
    "Amount",
    "Closing",
    "Status",
  ],
  asm: [
    "OrderId",
    "EST",
    "Operator",
    "Number",
    "Info",
    "Amount",
    "Closing",
    "Status",
  ],
  api: ["OrderId", "Operator", "Number", "Info", "Amount", "Closing", "Status"],
};
// only for transaction page
export const searchOptions = {
  admin: [
    { field: "Number", parameter: "number" },
    { field: "Account", parameter: "ben_acc" },
    { field: "Username", parameter: "username" },
  ],
  ad: [
    { field: "Number", parameter: "number" },
    { field: "Account", parameter: "ben_acc" },
  ],
  dd: [
    { field: "Number", parameter: "number" },
    { field: "Account", parameter: "ben_acc" },
  ],
  ret: [
    { field: "Number", parameter: "number" },
    { field: "Account", parameter: "ben_acc" },
  ],
  asm: [
    { field: "Number", parameter: "number" },
    { field: "Account", parameter: "ben_acc" },
  ],
  api: [
    { field: "Number", parameter: "number" },
    { field: "Account", parameter: "ben_acc" },
  ],
};

// NEPAL CONSTANTS

export const customerType = [
  { label: "Salaried", value: 1 },
  { label: "Self Employed including Professional", value: 2 },
  { label: "Farmer", value: 3 },
  { label: "Housewife", value: 4 },
];

export const SourceIncomeType = [
  { label: "Govt", value: 1 },
  { label: "Public sector", value: 2 },
  { label: "Private Sector", value: 3 },
  { label: "Business", value: 4 },
  { label: "Agriculture", value: 5 },
  { label: "Dependent", value: 6 },
];

export const annualIncome = [
  { label: "₹ 0.00 lacs - ₹ 2.00 Lacs", value: 1 },
  { label: "₹ 2.00 Lacs - ₹ 5 Lacs", value: 2 },
  { label: "₹ 5 Lacs - ₹ 10 Lacs", value: 3 },
  { label: "More than ₹ 10 Lacs", value: 4 },
];

export const genders = [
  { label: "Male", value: "MALE" },
  { label: "Female", value: "FEMALE" },
  { label: "Others", value: "OTHERS" },
];

export const PROJECTS = {
  imps: "ImpsGuru",
  paisakart: "PaisaKart",
  moneyoddr: "MoneyOddr",
};

export const AEPS_TYPE = {
  AEPS1: "aeps1",
  AEPS2: "aeps2",
  BOTH: "both",
};
export const TWOFASTATUS = {
  LOGINREQUIRED: "LOGINREQUIRED",
  LOGGEDIN: "LOGGEDIN",
};
export const COMPLAINT_STATUS = [
  {
    label: "Open",
    value: "OPEN",
  },
  {
    label: "Closed",
    value: "CLOSED",
  },
];

export const PRABHUTXN_TYPE = {
  PRABHU: ApiEndpoints.NEPAL_TRANSACTION,
  UNVERIFIED: ApiEndpoints.NEPAL_UVTRANSACTION,
  COMPLIANCE: ApiEndpoints.NEPAL_COMPLIANCE_TRANSACTION,
};
export const vendor_tab_value = {
  0: "express",
  1: "super",
};

export const USER_ROLES = {
  ADMIN: "Admin",
  ASM: "Asm",
  API: "Api",
  ACC: "Acc",
  RET: "Ret",
  DD: "Dd",
  MD: "Md",
  AD: "Ad",
};

export const ROLE_LIST = [
  {
    label: "Corporates",
    value: "Api",
  },
  {
    label: "Zonal Sales Manager",
    value: "Zsm",
  },
  {
    label: "Sales Manager",
    value: "Asm",
  },
  {
    label: "Area Distributor",
    value: "Ad",
  },
  {
    label: "Direct Dealer",
    value: "Dd",
  },
  {
    label: "Retailer",
    value: "Ret",
  },
];

export const OPERATORLIST = [
  {
    label: "AIR",
    value: "AIR",
  },
  {
    label: "JIO",
    value: "JIO",
  },
  {
    label: "VOD",
    value: "VOD",
  },
  {
    label: "IDE",
    value: "IDE",
  },
];

export const ROLE_LIST4AD = [
  {
    label: "Corporates",
    value: "Api",
  },
  {
    label: "Retailer",
    value: "Ret",
  },
];

// PIPE CONSTANTS USED IN ADMIN OPERATOR TABLE
export const PIPES = [
  { label: "Bank 1", value: "bank1" },
  { label: "Bank 2", value: "bank2" },
  { label: "Bank 3", value: "bank3" },
];

export const BOM = {
  id: 1,
  CityCode: "BOM",
  CityName: "Mumbai",
  CountryName: "India",
  Synonyms: "Bombay",
  AirportName: "Chhatrapati Shivaji International Airport",
  Domestic: 1,
  ActiveStatus: 1,
  TimeStamp: "0900.0",
  Continent: "Asia",
  Lattitude: "19.0912",
  Logitude: "72.866",
  Otherame: "Chatrapati Shivaji",
  CountryCounter: "0",
  created_at: "2023-08-15T05:08:13.000000Z",
  updated: "2023-08-15 05:08:13",
};
export const DEL = {
  id: 2,
  CityCode: "DEL",
  CityName: "New Delhi",
  CountryName: "India",
  Synonyms: "Delhi|Dilli",
  AirportName: "Indira Gandhi International Airport",
  Domestic: 1,
  ActiveStatus: 1,
  TimeStamp: "0900.0",
  Continent: "Asia",
  Lattitude: "28.5632",
  Logitude: "77.1183",
  Otherame: "Idira Gadhi",
  CountryCounter: "0",
  created_at: "2023-08-15T05:08:13.000000Z",
  updated: "2023-08-15 05:08:13",
};
export const BOOKINGSTEP = {
  REVIEW: "REVIEW",
  TRAVELLERS: "TRAVELLERS",
  PAYMENT: "PAYMENT",
};
export const REPORTS = [
  { name: "ACCOUNT LEDGER", url: "/customer/account-ledger" },
  { name: "COMPLAINTS", url: "/customer/complaints" },
  { name: "PURCHASE", url: "/customer/purchase" },
  { name: "KHATA BOOK", url: "/customer/khata-book" },
];

export const AD_REPORTS = [
  { name: "SALE", url: "/ad/sale" },
  { name: "PURCHASE", url: "/ad/purchase" },
  { name: "LEDGER", url: "/ad/ledger" },
  { name: "KHATA BOOK", url: "/ad/khata-book" },
];
export const MD_REPORTS = [
  { name: "SALE", url: "/md/sale" },
  { name: "PURCHASE", url: "/md/purchase" },
  { name: "LEDGER", url: "/md/ledger" },
  { name: "KHATA BOOK", url: "/md/khata-book" },
];

export const navigate_routes = {
  admin: "admin/dashboard",
  asm: "asm/dashboard",
  api: "api-user/dashboard",
  ad: "ad/dashboard",
  ret: "customer/dashboard",
  dd: "customer/dashboard",
  account: "account/dashboard",
  customer: "customer/dashboard",
};

// user table styled tab map
export const adminTab = [
  { label: "All", value: 0, icon: <Diversity2Icon /> },
  { label: "Corporates", value: 1, icon: <InterpreterModeIcon /> },
  { label: "ZSM", value: 2, icon: <Person2Icon /> },
  { label: "ASM", value: 3, icon: <RecordVoiceOverIcon /> },
  { label: "MD", value: 4, icon: <PersonIcon /> },
  { label: "AD", value: 5, icon: <SensorOccupiedIcon /> },
  { label: "DD", value: 6, icon: <Person4Icon /> },
  { label: "RET", value: 7, icon: <PersonIcon /> },
  { label: "IRCTC", value: 8, icon: <TrainIcon /> },
  { label: "UNVERIFIED", value: 9, icon: <PrivacyTipIcon /> },
];
export const asmTab = [
  { label: "All", value: 0 },
  { label: "Corporates", value: 1 },
  { label: "MD", value: 2 },
  { label: "AD", value: 3 },

  { label: "DD", value: 4 },
  { label: "RET", value: 5 },
  // { label: "IRCTC", value: 6 },
];
export const zsmTab = [
  { label: "All", value: 0 },
  { label: "Corporates", value: 1 },
  { label: "ASM", value: 2 },
  { label: "MD", value: 3 },
  { label: "AD", value: 4 },
  { label: "DD", value: 5 },
  { label: "RET", value: 6 },
  // { label: "IRCTC", value: 7 },
];
export const mdTab = [
  { label: "All", value: 0 },
  { label: "AD", value: 4 },
  { label: "RET", value: 6 },
  { label: "IRCTC", value: 7 },
];
export const adTab = [
  { label: "All", value: 0 },
  { label: "RET", value: 1 },
  { label: "IRCTC", value: 2 },
];
export const paymentModes = [
  {
    name: "IMPS",
    style: {
      backgroundColor: "#70AD47",
      color: "#fff",
      borderColor: "#70AD47",
    },
  },
  {
    name: "NEFT",
    style: {
      backgroundColor: "#5B9BD5",
      color: "#fff",
      borderColor: "#5B9BD5",
    },
  },
  {
    name: "UPI",
    style: {
      backgroundColor: "#3d5a80",
      color: "#fff",
      borderColor: "#3d5a80",
    },
  },
];

export const BeneKycStatus = [
  { label: "Completed", value: "1" },
  { label: "Pending", value: "2" },
  { label: "Not Done", value: "0" },
];
export const PaymentMethods = [
  { label: "Paytm", value: "paytm" },
  { label: "PhonePe", value: "ybl" },
  { label: "Google Pay (okhdfcbank)", value: "okhdfcbank" },
  { label: "Google Pay (okicici)", value: "okicici" },
  { label: "Google Pay (oksbi)", value: "oksbi" },
  { label: "Amazon Pay", value: "apl" },
  { label: "BHIM", value: "upi" },
  { label: "ICICI Bank", value: "icici" },
  { label: "HDFC Bank", value: "hdfcbank" },
  { label: "Axis Bank", value: "axisbank" },
  { label: "SBI (State Bank of India)", value: "sbi" },
  { label: "Kotak Mahindra Bank", value: "kotak" },
  { label: "Punjab National Bank (PNB)", value: "pnb" },
  { label: "Bank of Baroda", value: "barodampay" },
  { label: "Yes Bank", value: "yesbank" },
  { label: "Other", value: "Other" },
];

export const mt_tab_value = {
  0: "dmt1",
  1: "dmt2",
  2: "express",
  3: "super",
  4: "nepal",
  5: "upi",
};
export const cms_tab_value = {
  0: "cms1",
  1: "cms2",
};
export const Transaction_Tab = {
  0: "",
  1: "PREPAID",
  2: "DTH",
  3: "UTILITY",
  4: "VERIFICATION",
  5: "MONEY TRANSFER",
  6: "COLLECTIONS",
  7: "IRCTC",
  8: "PAYMENTS",
};
export const travel_Tab = {
  0: "AIR",
  1: "BUS",
  2: "HOTELS",
  3: "TRAIN",
};

export const Status = [
  { label: "APPROVED", value: "APPROVED" },
  { label: "REJECTED", value: "REJECTED" },
  { label: "PENDING", value: "PENDING" },
];

export const my_profile = {
  0: "personal",
  1: "business",
  2: "bank",
  3: "document",
  4: "authentication",
  5: "bc",
  6: "irctc",
};
export const Admin_profile = {
  0: "personal",
  1: "business",

  2: "document",
  3: "authentication",
  4: "service",
};
export const Categories = [
  {
    id: 1,
    name: "PREPAID",
    created_at: "2022-05-24T05:14:04.000000Z",
    updated_at: "2022-05-24T05:14:04.000000Z",
  },
  {
    id: 2,
    name: "DTH",
    created_at: "2022-05-24T05:14:04.000000Z",
    updated_at: "2022-05-24T05:14:04.000000Z",
  },
  {
    id: 3,
    name: "UTILITY",
    created_at: "2022-05-24T05:14:35.000000Z",
    updated_at: "2022-05-24T05:14:35.000000Z",
  },
  {
    id: 4,
    name: "VERIFICATION",
    created_at: "2022-05-24T05:14:35.000000Z",
    updated_at: "2022-05-24T05:14:35.000000Z",
  },
  {
    id: 5,
    name: "MONEY TRANSFER",
    created_at: "2022-05-24T05:15:00.000000Z",
    updated_at: "2022-05-24T05:15:25.000000Z",
  },
  {
    id: 6,
    name: "COLLECTIONS",
    created_at: "2022-05-24T05:15:00.000000Z",
    updated_at: "2022-05-24T05:15:00.000000Z",
  },
  {
    id: 7,
    name: "IRCTC",
    created_at: "2022-05-24T05:15:08.000000Z",
    updated_at: "2022-05-24T05:15:08.000000Z",
  },
  {
    id: 8,
    name: "ADMIN TRANSFER",
    created_at: "2022-05-24T05:16:19.000000Z",
    updated_at: "2022-08-22T07:44:44.000000Z",
  },
  {
    id: 9,
    name: "SECONDARY",
    created_at: "2022-05-24T05:16:19.000000Z",
    updated_at: "2022-05-24T05:16:19.000000Z",
  },
  {
    id: 10,
    name: "W2W TRANSFER",
    created_at: "2022-05-24T05:16:46.000000Z",
    updated_at: "2022-05-24T05:16:46.000000Z",
  },
  {
    id: 11,
    name: "PAYMENTS",
    created_at: "2022-05-24T05:16:46.000000Z",
    updated_at: "2022-05-24T05:16:46.000000Z",
  },
  {
    id: 12,
    name: "CMS",
    created_at: "2022-05-24T05:16:46.000000Z",
    updated_at: "2022-05-24T05:16:46.000000Z",
  },
];
export const employees = [
  {
    id: 1,
    name: "Raushan Kumar",
    position: "Software Engineer",
    department: "Engineering",
    email: "john.doe@example.com",
    phone: "+91 8851980670",
    image: maleAvatar,
    details:
      "My name is Raushan Kumar.I am a front-end developer at Biggbrains",
    icon: <AddAPhotoIcon />,
    icon1: <CalendarMonthIcon />,
    icon2: <StarIcon />,
  },
  {
    id: 2,
    name: "Anshul",
    position: "Software Engineer",
    department: "Product",
    email: "jane.smith@example.com",
    phone: "+91 8368767370",
    image: maleAvatar,
    details: "My name is Anshul.I am a back-end developer at Biggbrain",
    icon: <AddAPhotoIcon />,
    icon1: <CalendarMonthIcon />,
    icon2: <StarIcon />,
  },
  {
    id: 3,
    name: "Vinay",
    position: "Software Engineer",
    department: "Product",
    email: "jane.smith@example.com",
    phone: "+91 9625271066",
    image: maleAvatar,
    details: "My name is Vinay.I am a front-end developer at Biggbrain",
    icon: <AddAPhotoIcon />,
    icon1: <CalendarMonthIcon />,
    icon2: <StarIcon />,
  },
  {
    id: 4,
    name: "Dev",
    position: "Software Engineer",
    department: "Product",
    email: "jane.smith@example.com",
    phone: "+91 9911971501",
    image: maleAvatar,
    details: "My name is Dev.I am a front-end developer at Biggbrain",
    icon: <AddAPhotoIcon />,
    icon1: <CalendarMonthIcon />,
    icon2: <StarIcon />,
  },
];
export const clients = [
  {
    id: 1,
    name: "Shanky ",
    position: "Dillipay",
    department: "Engineering",
    email: "john.doe@example.com",
    phone: "+91 8851980670",
    image: client_men,
    details: "I am the CEO of Dillipay Technologies Ltd.",
    icon: <DeleteOutlineOutlinedIcon />,
    icon2: <EditOutlinedIcon />,
  },
  {
    id: 2,
    name: "Vipul",
    position: "Vdeepay",
    department: "Product",
    email: "jane.smith@example.com",
    phone: "+91 8368767370",
    image: client_men,
    details: "I am the owner of the Vdeepay Technologies Ltd.",
    icon: <DeleteOutlineOutlinedIcon />,
    icon2: <EditOutlinedIcon />,
  },
  {
    id: 3,
    name: "Himanshu",
    position: "Payfusionx",
    department: "Product",
    email: "jane.smith@example.com",
    phone: "+91 9625271066",
    image: client_men,
    details: "I am the owner of the company payfusionx pvt. ltd.",
    icon: <DeleteOutlineOutlinedIcon />,
    icon2: <EditOutlinedIcon />,
  },
];
export const projectsData = [
  {
    id: 1,
    category: "Dillipay Technology",
    title: "React Js",
    icon: "🎨",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 70,
    daysLeft: 35,
    status: "Started",
  },
  {
    id: 1,
    category: "Tax Buddy",
    title: "React Js",
    icon: "🎨",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 70,
    daysLeft: 35,
    status: "Started",
  },
  {
    id: 2,
    category: "VdeePay Technology",
    title: "React Js",
    icon: "🖥️",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 60,
    daysLeft: 35,
    status: "Approval",
  },
  {
    id: 2,
    category: "PayFusion Technology",
    title: "React Js",
    icon: "🖥️",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 60,
    daysLeft: 35,
    status: "Approval",
  },
  {
    id: 3,
    category: "Fusion Pay",
    title: "App Development",
    icon: "📱",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 80,
    daysLeft: 35,
    status: "Completed",
  },
  {
    id: 3,
    category: "Vdeepay Pay",
    title: "App Development",
    icon: "📱",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 80,
    daysLeft: 35,
    status: "Completed",
  },
  {
    id: 4,
    category: "We2pay Technology",
    title: "App Development",
    icon: "📱",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 80,
    daysLeft: 35,
    status: "Completed",
  },
  {
    id: 5,
    category: "Brajpay Technology",
    title: "App Development",
    icon: "📱",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 80,
    daysLeft: 35,
    status: "Completed",
  },
  {
    id: 6,
    category: "Trustpay India Technology",
    title: "App Development",
    icon: "📱",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 80,
    daysLeft: 35,
    status: "Completed",
  },
  {
    id: 7,
    category: "Digivochers Technology",
    title: "App Development",
    icon: "📱",
    members: 5,
    attachments: 5,
    duration: "4 Month",
    comments: 10,
    progress: 80,
    daysLeft: 35,
    status: "Completed",
  },
];

export const user_Tab = [
  {
    0: "All",
    1: "Developer",
    2: "Merchant",
  },
];

  const yyyymmdd = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  // Check if date is after today
  const afterToday = () => {
    return (date) => {
      if (!date) return false;
      return date > new Date();
    };
  };

export const predefinedRanges = [
  {
    label: "Today",
    value: [new Date(), new Date()],
  },
  {
    label: "Yesterday",
    value: [
      new Date(new Date().setDate(new Date().getDate() - 1)),
      new Date(new Date().setDate(new Date().getDate() - 1)),
    ],
  },
  {
    label: "This Week",
    value: [
      new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
      new Date(),
    ],
  },
  {
    label: "Last 7 Days",
    value: [new Date(new Date().setDate(new Date().getDate() - 6)), new Date()],
  },
  {
    label: "This Month",
    value: [
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      new Date(),
    ],
  },
  {
    label: "Last Month",
    value: [
      new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
      new Date(new Date().getFullYear(), new Date().getMonth(), 0),
    ],
  },
];
